/**
 * Texto de la línea de estado mientras se responde (maqueta 2026-10-14-pensando.html, aprobada por el dueño).
 * Motor nuevo: sigue los eventos SSE `stage` (understand → search → read → write → verify).
 * Camino viejo: el rótulo de la herramienta en curso; sin herramienta, «Redactando…» si ya llega texto.
 */
export interface Stage {
  etapa: string;
  detalle?: unknown;
}

export interface ActiveTool {
  tool: string;
  status: 'loading' | 'done';
}

const TOOL_LABELS: Record<string, string> = {
  buscar_normativa: 'Buscando normativa',
  analizar_documento: 'Analizando el documento',
  comparar_criterios: 'Comparando criterios',
  explicar_concepto: 'Explicando el concepto',
  encontrar_similares: 'Buscando documentos similares',
  buscar_jurisprudencia: 'Buscando jurisprudencia',
  consultar_convenio: 'Consultando el convenio',
};

export function stageLabel(stage: Stage): string {
  switch (stage.etapa) {
    case 'understand': return 'Entendiendo la pregunta…';
    case 'search': return 'Buscando en leyes, oficios y circulares…';
    case 'read': {
      const n = typeof stage.detalle === 'number' ? stage.detalle : 0;
      if (n <= 0) return 'Leyendo los documentos…';
      return `Leyendo ${n} ${n === 1 ? 'documento' : 'documentos'}…`;
    }
    case 'write': return 'Redactando…';
    case 'verify': return 'Revisando las citas…';
    default: return 'Pensando…';
  }
}

export function statusLabel({ stage, activeTools, hasContent }: { stage: Stage | null; activeTools: ActiveTool[]; hasContent: boolean }): string {
  if (stage) return stageLabel(stage);
  const running = [...activeTools].reverse().find(t => t.status === 'loading');
  if (running) return `${TOOL_LABELS[running.tool] || running.tool.replace(/_/g, ' ')}…`;
  return hasContent ? 'Redactando…' : 'Pensando…';
}
